import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07124204"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrap fs-s"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fw-b fs-l pb-20"
}, "WELL碳手印知识库", -1));
import { ref, onMounted } from 'vue';
import ResList from '../components/ResList.vue';
import request from '@/utils/request.js';
export default {
  __name: 'KnowledgeBase',
  setup(__props) {
    let listData = ref([]);
    function getList() {
      request({
        url: '/knowledge_base.json',
        method: 'get'
      }).then(res => {
        listData.value = res.data;
      });
    }
    let vvr = ref();
    function initVideo() {
      console.log(vvr.value);
      // vvr.value.fullscreen = {
      //         enterOnRotate: true, //在横向旋转设备时进入全屏模式
      //         alwaysInLandscapeMode: true, //即使设备处于纵向模式，也始终以横向模式进入全屏（适用于 chromium、firefox 和 ie>=11）
      //         iOS: true // 是否在 iOS 上使用假全屏（显示播放器控件而不是系统控件所需）
      //     };
      // 配置横屏插件
      // player.landscapeFullscreen({
      //     fullscreen: {
      //         enterOnRotate: true, //在横向旋转设备时进入全屏模式
      //         alwaysInLandscapeMode: true, //即使设备处于纵向模式，也始终以横向模式进入全屏（适用于 chromium、firefox 和 ie>=11）
      //         iOS: true // 是否在 iOS 上使用假全屏（显示播放器控件而不是系统控件所需）
      //     }
      // });
    }

    onMounted(() => {
      // initVideo()
      getList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(ResList, {
        list: _unref(listData)
      }, null, 8, ["list"])]);
    };
  }
};